import { Typography } from '@mui/material';

import { AttendanceType } from '../constants';
import {
  FORTA_BLACK,
  FORTA_BLUE,
  FORTA_BROWN,
  FORTA_ERROR_2,
  FORTA_SUCCESS,
  FORTA_SUCCESS_2,
  FORTA_YELLOW,
  FORTA_YELLOW_2,
} from '../../../../utils/colors';

interface IAttendanceTagProps {
  type: AttendanceType;
  sx?: any;
}

function AttendanceTag({ type, sx = {} }: IAttendanceTagProps) {
  return (
    <Typography
      sx={{
        backgroundColor:
          type === AttendanceType.Full
            ? FORTA_SUCCESS_2
            : type === AttendanceType.Partial
              ? FORTA_YELLOW_2
              : FORTA_ERROR_2,
        border: `2px solid ${
          type === AttendanceType.Full
            ? FORTA_SUCCESS
            : type === AttendanceType.Partial
              ? FORTA_YELLOW
              : FORTA_ERROR_2
        }`,
        minHeight: '30px',
        fontWeight: 700,
        fontSize: type === AttendanceType.Correction ? 14 : 16,
        color:
          type === AttendanceType.Full
            ? FORTA_BLUE.primary
            : type === AttendanceType.Partial
              ? FORTA_BROWN
              : FORTA_BLACK,
        px: 1,
        py: 0.3,

        width: 'fit-content',
        lineHeight: '21px',
        borderRadius: '10px',
        display: 'inline',
        ...sx,
      }}
    >
      {type}
    </Typography>
  );
}

export default AttendanceTag;
